module.exports = __webpack_public_path__ + "static/media/goFirst.ae38fa39.svg";